import { Layout, SignalRecording } from "components"
export const SignalTimingRecording = () => {
 return (
  <Layout>
   <SignalRecording />
  </Layout>
 )
}
